export default __webpack_public_path__ + "static/media/logoPor.f8be7426.png";